import SurveyReview from './components/SurveyGuide';

interface SurveyGuidePageProps {
    onStart: () => void;
    isSelfEvaluation?: boolean;
}

const SurveyGuidePage = ({ onStart, isSelfEvaluation }: SurveyGuidePageProps) => {
    return (
        <SurveyReview
            onStart={onStart}
            isSelfEvaluation={isSelfEvaluation}
        />
    );
};

export default SurveyGuidePage;
